import React from "react";
import { useTranslation } from "../../../../i18n/LanguageContext";
import "../../css/Common.css";
import "./css/EmailManualScan.css";
import "./css/EmailAnalysisSimple.css";
import "./css/EmailAnalysisSimpleDesktop.css";

// Import sub-components
import AnalysisResultsSimple from "./components/AnalysisResultsSimple";
import AnalysisDetailsSimple from "./components/AnalysisDetailsSimple";
import EmailCheckStart from "./components/EmailCheckStart";
import DisclosuresModal from "../common/DisclosuresModal";
import HelpGuideButton from "../../HelpGuideButton";

const EmailAnalysisSimpleDesktop = ({
  selectedAnalysis,
  analyses,
  handleAnalysisSelected,
  handleReanalyzeWithContext,
  refreshAnalyses,
  userUuid,
  setError,
  scrollToAnalysisResults,
  onAnalysisDeleted,
  reportIdMap = {},
  onNavigateToManual,
  userEmail,
  awaitState,
  onStartAwaiting,
  onCancelAwaiting,
  forwardingDisabled,
  hasLoaded = true,
}) => {
  const isMobile = () => window.innerWidth <= 768;
  const { t } = useTranslation();
  const hasHistory = analyses.length > 0;

  return (
    <>
      <div className="common-header">
        <h1 className="main-title">{t("email.page.title")}</h1>
        <div className="subtitle-with-help">
          <p className="common-subtitle">{t("email.page.subtitle")}</p>
          {hasHistory && <HelpGuideButton guideId={1} />}
        </div>
      </div>

      {hasLoaded && (
        <EmailCheckStart
          variant={hasHistory ? "compact" : "full"}
          userEmail={userEmail}
          awaitState={awaitState}
          onStartAwaiting={onStartAwaiting}
          onCancelAwaiting={onCancelAwaiting}
          onPasteInstead={onNavigateToManual}
          forwardingDisabled={forwardingDisabled}
        />
      )}

      {hasHistory && (
        /* Two-Panel Layout to match Social Media Analysis */
        <div className="analysis-layout two-panel">
          {/* Left Panel - Email Analysis List (45%) */}
          <div className="left-panel">
            {/* <div className="panel-content email-analysis-simple-desktop-panel-content"> */}
            <AnalysisResultsSimple
              rawAnalyses={analyses}
              selectedAnalysis={selectedAnalysis}
              onAnalysisClick={handleAnalysisSelected}
              onRefresh={refreshAnalyses}
              userUuid={userUuid}
              onError={setError}
              onAnalysisDeleted={onAnalysisDeleted}
              isMobile={isMobile()}
              onNavigateToManual={onNavigateToManual}
            />
            {/* </div> */}
          </div>

          {/* Right Panel - Analysis Details (54.5%) */}
          <div className="right-panel">
            {/* <div className="panel-content email-analysis-simple-desktop-panel-content"> */}
            {/* <div className="case-details email-analysis-simple-desktop-case-details"> */}
            <AnalysisDetailsSimple
              selectedAnalysis={selectedAnalysis}
              onScrollToAnalysisResults={scrollToAnalysisResults}
              onReanalyzeWithContext={handleReanalyzeWithContext}
              reportId={
                selectedAnalysis?.reportId || reportIdMap[selectedAnalysis?.key]
              }
            />
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>
      )}

      <DisclosuresModal disclaimerText={t("email.disclaimer")} />
    </>
  );
};

export default EmailAnalysisSimpleDesktop;
